<template>
  <div>
    <ve-histogram height="300px" :data="sourceData" :extend="downChartExtend" class="subCharts"></ve-histogram>
  </div>
</template>
<script>
/*eslint-disable*/
export default {
  name: "barChart",
  data() {
    return {
      sourceData: {
        columns: [],
        rows: []
      },
      downChartExtend: {
        //公共柱状图设置
        legend: {
          show: false
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: {
          axisLabel: {
            show: true,
            interval: 10,
            // rotate: -60,
            // margin: 5,
            textStyle: {
              color: "#666",
              fontSize: 10
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#ebedf0"
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed"
              }
            }
          },
          grid: {
            //    x: 40,
            x2: 10, //图与右侧的边距
            y2: 80 //图与下边的边距
          }
        },
        yAxis: {
          axisLabel: {
            textStyle: {
              color: "#999",
              fontSize: 14
            }
          },

          axisLine: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed"
            }
          }
        }
      }
    };
  },
  props: {
    sourceList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  model: {
    prop: "sourceList"
  },
  mounted() {
    this.$nextTick(() => {
      if (this.sourceList) {
        this.initPage();
      }
    });
  },
  methods: {
    initPage() {
      let _this = this;
      this.sourceData.columns = ["类型", "数量"];
      let NewObject = {};
      for (let i = 0; i < _this.sourceList.length; i++) {
        NewObject = {
          '类型': _this.sourceList[i].type,
          '数量': _this.sourceList[i].numbers
        };
        _this.sourceData.rows.push(NewObject);
      }
    }
  },
  watch: {
    sourceList: function() {
      this.initPage();
    }
  }
};
</script>
<style lang="less">
</style>